import { PinOff } from 'lucide-react';
import { useT } from '../../i18n';
import { NavMenuItems } from './NavMenuItems';

export interface PinnedSidebarProps {
  /** Currently active view id (drives the active-item styling). */
  currentView: string;
  /** Navigate to the given view id. */
  onNavigate: (id: string) => void;
  /** Unpin the sidebar (revert to the hamburger menu). */
  onUnpin: () => void;
  /** Badge count shown on the archive item. */
  archiveCount?: number;
  /** The live Padel24Engine wiring object (still defined in legacy/App.tsx); forwarded to NavMenuItems for the version footer. */
  Padel24Engine: any;
}

export function PinnedSidebar({
  currentView,
  onNavigate,
  onUnpin,
  archiveCount = 0,
  Padel24Engine,
}: PinnedSidebarProps) {
  const t = useT();
  return (
    <aside className="flex-shrink-0" style={{ width: 200 }}>
      <div
        className="sticky top-14 pt-4 pr-4"
        style={{ maxHeight: 'calc(100vh - 56px)', overflowY: 'auto' }}
      >
        <div className="card-elev p-2 rounded-xl">
          <NavMenuItems
            currentView={currentView}
            onNavigate={onNavigate}
            Padel24Engine={Padel24Engine}
            archiveCount={archiveCount}
            headerSlot={
              <button
                onClick={onUnpin}
                className="p-1.5 rounded hover:bg-bg-soft transition-colors text-ink-3 hover:text-ink-2"
                title={t('ui.nav.unpin')}
              >
                <PinOff size={14} />
              </button>
            }
          />
        </div>
      </div>
    </aside>
  );
}
